import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { articleCards } from '@/mocks/categories';

export default function ArticleCardsSection() {
  const { t } = useTranslation();

  return (
    <section className="w-full bg-background-100/50">
      <div className="w-full px-6 md:px-10 py-20 md:py-28">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-12">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-accent-100/50 rounded-full mb-5">
              <span className="text-xs font-medium text-accent-700">Poradniki Kakobuy</span>
            </div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 mb-4">
              {t('articles_section.title')}
            </h2>
            <p className="text-base text-foreground-600 max-w-2xl mx-auto">
              {t('articles_section.subtitle')}
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {articleCards.map((card) => (
              <Link
                key={card.seq}
                to={`/artykul/${card.slug}/`}
                className="group bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all cursor-pointer flex flex-col"
              >
                <div className="w-full aspect-[16/10] overflow-hidden bg-secondary-50">
                  <img
                    src={card.image}
                    alt={card.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                </div>
                <div className="p-5 md:p-6 flex flex-col flex-1">
                  <h3 className="text-base md:text-lg font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                    {card.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-4 flex-1 line-clamp-2">
                    {card.excerpt}
                  </p>
                  <div className="flex items-center gap-2 text-xs font-medium text-primary-500">
                    <span>Czytaj więcej</span>
                    <span className="w-4 h-4 flex items-center justify-center group-hover:translate-x-0.5 transition-transform">
                      <i className="ri-arrow-right-line text-xs"></i>
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>

          <div className="text-center mt-12">
            <Link
              to="/artykul/kakobuy-spreadsheet-poradnik/"
              className="group inline-flex items-center gap-2 px-6 py-3.5 bg-foreground-900 text-background-50 font-medium rounded-full hover:bg-foreground-800 transition-all whitespace-nowrap cursor-pointer"
            >
              <span>Zobacz wszystkie poradniki</span>
              <span className="w-7 h-7 flex items-center justify-center bg-background-50/20 rounded-full group-hover:translate-x-0.5 transition-transform">
                <i className="ri-arrow-right-line text-sm"></i>
              </span>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}